export default {
    Alert: 'JRCAlert',
    AppColumn: 'JRCAppColumn',
    AppContainer: 'JRCAppContainer',
    AppHeader: 'JRCAppHeader',
    AppLeftColumn: 'JRCAppLeftColumn',
    Attachments: 'JRCAttachments',
    BaseTooltip: 'JRCBaseTooltip',
    BETA_DragAndDrop: 'BETA_JRCDragAndDrop',
    Button: 'JRCButton',
    ButtonDownload: 'JRCButtonDownload',
    ButtonDropdown: 'JRCButtonDropdown',
    ButtonFile: 'JRCButtonFile',
    Card: 'JRCCard',
    CardImg: 'JRCCardImg',
    Checkbox: 'JRCCheckbox',
    ClickAwayListener: 'ClickAwayListener',
    Collapse: 'JRCCollapse',
    Column: 'JRCColumn',
    ColumnCenter: 'JRCColumnCenter',
    ColumnLeft: 'JRCColumnLeft',
    ColumnRight: 'JRCColumnRight',
    ConditionalWrapper: 'JRCConditionalWrapper',
    Container: 'JRCContainer',
    CropImage: 'JRCCropImage',
    BasicAutoMarginContainer: 'JRCBasicAutoMarginContainer',
    Date: 'JRCDate',
    DisplayCard: 'JRCDisplayCard',
    DriveMSGraph: 'JRCDriveMSGraph',
    DriveDropbox: 'JRCDriveDropbox',
    DEPRECATEDFormAutocompleteAudienceField: 'JRCFormAutocompleteAudienceField',
    DEPRECATEDFormAutocompleteCommunityField: 'JRCFormAutocompleteCommunityField',
    DEPRECATEDFormAutocompleteTaxonomyField: 'JRCFormAutocompleteTaxonomyField',
    DEPRECATEDFormCheckbox: 'JRCFormCheckbox',
    DEPRECATEDFormColorField: 'JRCFormColorField',
    DEPRECATEDFormEmailField: 'JRCFormEmailField',
    DEPRECATEDFormInputFileField: 'JRCFormInputFileField',
    DEPRECATEDFormInputImageField: 'JRCFormInputImageField',
    DEPRECATEDFormNumberField: 'JRCFormNumberField',
    DEPRECATEDFormRangeField: 'JRCFormRangeField',
    DEPRECATEDFormReceiveACopyField: 'JRCFormReceiveACopyField',
    DEPRECATEDFormRichTextField: 'JRCFormRichTextField',
    DEPRECATEDFormSelectField: 'JRCFormSelectField',
    DEPRECATEDFormSelectInput: 'JRCFormSelectInput',
    DEPRECATEDFormSelectTagField: 'JRCFormSelectTagField',
    DEPRECATEDFormSendAlertField: 'JRCFormSendAlertField',
    DEPRECATEDFormTextarea: 'JRCFormTextarea',
    DEPRECATEDFormTextareaField: 'JRCFormTextareaField',
    DEPRECATEDFormTextField: 'JRCFormTextField',
    DEPRECATEDFormUrlField: 'JRCFormUrlField',
    DoubleClick: 'BETA_JRCDoubleClick',
    DraggingPlaceholder: 'JRCDraggingPlaceholder',
    DropDown: 'JRCDropDown',
    Ellipsis: 'JRCEllipsis',
    EmptySpace: 'JRCEmptySpace',
    FadeStepper: 'JRCFadeStepper',
    File: 'JRCFile',
    FileAvatar: 'JRCFileAvatar',
    FileOpen: 'JRCFileOpen',
    FileViewer: 'JRCFileViewer',
    FlexBox: 'JRCFlexBox',
    Folders: 'JRCFolders',
    Grid: 'JRCGrid',
    H1: 'JRCH1',
    H2: 'JRCH2',
    H3: 'JRCH3',
    H4: 'JRCH4',
    H5: 'JRCH5',
    Html: 'JRCHtml',
    Icon: 'JRCIcon',
    IconButton: 'JRCIconButton',
    ImageStepper: 'JRCImageStepper',
    Img: 'JRCImg',
    InputAudience: 'JRCInputAudience',
    InputAutocomplete: 'JRCInputAutocomplete',
    InputCheckbox: 'JRCInputCheckbox',
    InputCheckboxRaw: 'JRCInputCheckboxRaw',
    InputColor: 'JRCInputColor',
    InputColorRaw: 'JRCInputColorRaw',
    InputCommunity: 'JRCInputCommunity',
    InputDate: 'JRCInputDate',
    InputDateTime: 'JRCInputDateTime',
    InputEmail: 'JRCInputEmail',
    InputFile: 'JRCInputFile',
    InputFileAdvancedRaw: 'JRCInputFileAdvancedRaw',
    InputImage: 'JRCInputImage',
    InputNumber: 'JRCInputNumber',
    InputReorderCheckbox: 'JRCInputReorderCheckbox',
    InputSearchRaw: 'JRCInputSearchRaw',
    InputSelect: 'JRCInputSelect',
    InputSelectExtended: 'JRCInputSelectExtended',
    InputSelectHierarchicalTree: 'JRCInputSelectHierarchicalTree',
    InputSelectList: 'JRCInputSelectList',
    InputSelectRaw: 'JRCInputSelectRaw',
    InputText: 'JRCInputText',
    InputTextarea: 'JRCInputTextarea',
    InputTextareaRaw: 'JRCInputTextareaRaw',
    InputPassword: 'JRCInputPassword',
    InputTextIconButton: 'JRCInputTextIconButton',
    InputTextRaw: 'JRCInputTextRaw',
    InputTime: 'JRCInputTime',
    InputTinyMCE: 'JRCInputTinyMCE',
    InputTinyMCERaw: 'JRCInputTinyMCERaw',
    InputToggle: 'JRCInputToggle',
    InputToggleRaw: 'JRCInputToggleRaw',
    InputUrl: 'JRCInputUrl',
    List: 'JRCList',
    Loader: 'JRCLoader',
    MainColumn: 'JRCMainColumn',
    Menu: 'JRCMenu',
    Message: 'JRCMessage',
    Modal: 'JRCModal',
    ModalContent: 'JRCModalContent',
    ModalContentForm: 'JRCModalContentForm',
    ModalForm: 'JRCModalForm',
    ModalImg: 'JRCModalImg',
    ModalUserList: 'JRCModalUserList',
    ModalLayout: 'JRCModalLayout',
    PageNotLogged: 'JRCPageNotLogged',
    Pagination: 'JRCPagination',
    Panel: 'JRCPanel',
    ProgressBar: 'JRCProgressBar',
    Resources: 'Resources',
    SidePanelModal: 'JRCSidePanelModal',
    SkeletonLine: 'JRCSkeletonLine',
    SkeletonList: 'JRCSkeletonList',
    SkeletonSquare: 'JRCSkeletonSquare',
    Stepper: 'JRCStepper',
    StepperPage: 'JRCStepperPage',
    StyledHref: 'JRCStyledHref',
    StyledInput: 'StyledInput',
    Tabs: 'JRCTabs',
    Tag: 'JRCTag',
    TemplateBase: 'JRCTemplateBase',
    TemplateTwoColumns: 'JRCTemplateTwoColumns',
    Text: 'JRCText',
    Theme: 'Theme',
    ThemeProvider: 'JRCThemeProvider',
    TinyMCEFileUploadModal: 'JRCTinyMCEFileUploadModal',
    TinyMCEImageUploadModal: 'JRCTinyMCEImageUploadModal',
    TinyMCEVideoUploadModal: 'JRCTinyMCEVideoUploadModal',
    Tooltip: 'JRCTooltip',
    Typography: 'JRCTypography',
    UserPopup: 'JRCUserPopup',
    ValidationButton: 'JRCValidationButton',
    WidgetAttachment: 'JRCWidgetAttachment',
    WidgetArticleAttachmentEditor: 'JRCWidgetArticleAttachmentEditor',
    WidgetButton: 'JRCWidgetButton',
    WidgetButtonEditor: 'JRCWidgetButtonEditor',
    WidgetArticleGallery: 'JRCWidgetArticleGallery',
    WidgetArticleGalleryEditor: 'JRCWidgetArticleGalleryEditor',
    WidgetImage: 'JRCWidgetImage',
    WidgetImageEditor: 'JRCWidgetImageEditor',
    WidgetArticleImageEditor: 'JRCWidgetArticleImageEditor',
    WidgetArticleSliderEditor: 'JRCWidgetArticleSliderEditor',
    WidgetArticleText: 'JRCWidgetArticleText',
    WidgetArticleTextEditor: 'JRCWidgetArticleTextEditor',
    WidgetArticleTitle: 'JRCWidgetArticleTitle',
    WidgetArticleTitleEditor: 'JRCWidgetArticleTitleEditor',
    WidgetTable: 'JRCWidgetTable',
    WidgetTableEditor: 'JRCWidgetTableEditor',
    WidgetDatasourceTableEditor: 'JRCWidgetDatasourceTableEditor',
    WidgetExcelDatasourceTableEditor: 'JRCWidgetExcelDatasourceTableEditor',
    WidgetLuccaAbsence: 'JRCWidgetLuccaAbsence',
    WidgetLuccaAbsenceEditor: 'JRCWidgetLuccaAbsenceEditor',
    WidgetPresence: 'JRCWidgetPresence',
    WidgetPresenceEditor: 'JRCWidgetPresenceEditor',
    WidgetSlider: 'JRCWidgetSlider',
    WidgetEmptyInplace: 'JRCWidgetEmptyInplace',
    WidgetCheckList: 'JRCWidgetCheckList',
    WidgetCheckListEditor: 'JRCWidgetCheckListEditor',
    WidgetQuickSurvey: 'JRCWidgetQuickSurvey',
    WidgetQuickSurveyEditor: 'JRCWidgetQuickSurveyEditor',
    WidgetContactCardDav: 'JRCWidgetContactCardDav',
    WidgetContactCardDavEditor: 'JRCWidgetContactCardDavEditor',
    WidgetEmailsImap: 'JRCWidgetEmailsImap',
    WidgetEmailsImapLevel2: 'JRCWidgetEmailsImapLevel2',
    WidgetIcon: 'JRCWidgetIcon',
    WidgetEmailsImapEditor: 'JRCWidgetEmailsImapEditor',
    WidgetCalendarCalDav: 'JRCWidgetCalendarCalDav',
    WidgetCalendarCalDavEditor: 'JRCWidgetCalendarCalDavEditor',
    // Wrapped components

    JRCAvatar: 'JRCAvatar',
    JRCCommentsBloc: 'JRCCommentsBloc',
} as const;
